import React, { useState } from "react"
import { DebounceInput } from "react-debounce-input"
import { defineMessages, injectIntl } from "react-intl"
import LabelSelect from "../../common/label/selection.component"
import { ProductSearchFilterProps } from "../../common/types/productItemList"
import IntlProps from "../../state/helpers/IntlProps"

const messages = defineMessages({
    "search_product_placeholder": {
        id: "product.components.product_search_modal.placeholder.search_product",
        defaultMessage: "Search products...",
    },
    "label_filter_placeholder": {
        id: "product.components.product_search_modal.label_filter_placeholder",
        defaultMessage: "Filter by label",
    }
})

const ProductSearchFilter = (props: ProductSearchFilterProps & IntlProps) => {
    const [labelFilters, setLabelFilters] = useState(props.filters)

    const handleKeywordsChange = (event) => {
        const keywords = event.target.value
        props.onKeywordsChangeCallback(keywords)
    }

    const handleFiltersChange = (items) => {
        props.onFiltersChangeCallback(items)
        setLabelFilters(items)
    }

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-md-6 col-12">
                    <DebounceInput
                        minLength={0}
                        autoComplete="off"
                        name="searchKeywords"
                        id="searchKeywords"
                        type="text"
                        className="form-control"
                        value={props.searchKeywords}
                        onChange={handleKeywordsChange}
                        debounceTimeout={500}
                        placeholder={props.intl.formatMessage(messages["search_product_placeholder"])}
                    />
                </div>
                <div className="col-md-6 col-12">
                    <LabelSelect
                        placeholder={props.intl.formatMessage(messages["label_filter_placeholder"])}
                        value={labelFilters}
                        onChange={e => handleFiltersChange(e)}
                        multi={true}
                        id={"filtersIds"}
                    />
                </div>
            </div>
        </div>
    )

}

export default injectIntl(ProductSearchFilter)




// WEBPACK FOOTER //
// ./src/product/components/ProductSearchFilter.tsx